<template>
  <div class="culture base-pad">
    <div class="title">
      <img :src="zh_en == 'zh' ? STATICURL + bgimg.culture_bgimg : STATICURL + culture_bgimg_en"
        style="width: 100%;height: 100%;" alt="">

    </div>


    <img src="../static/images/culture.png" style="width: 100%; position: absolute;bottom: 0;left: 0;" alt="">

    <div class="content">
      <div class="detail">

        <div class="titlebox">
          <div style="color: #8a2e26;font-size: 28px;font-weight: bold;">{{ zh_en == 'zh' ? '品牌文化' : 'Brand Culture' }}</div>
          <div style="display: flex;">
            <div class="default" :class='activityIndex == index ? "activity" : ""' v-for="(item, index) in tabList"
              :key="index" @click="change(index)">{{ item }}</div>
          </div>

          <img src="@/static/images/cultureTitile.png" style="width: 100%;position: absolute;bottom: 0;left: 0;"
            mode="widthFix" />
        </div>

        <div class="contentbox" v-if="isShowList">

          <div
            style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-bottom: 24px;">
            <div style="color: #181818; font-size: 28px;font-weight: 600;margin-bottom: 5px;margin-top: 15px;">{{
              tabList[activityIndex] }}</div>
            <div style="width: 82px;height: 7px;border-radius: 3px;background-color: #8a2e26;"></div>
          </div>




          <div v-if="activityIndex == 0">
            <div class="timeline-container" v-for="(item, index) in brand_event_list" :key='index'>
              <div class="timeline-year" style="text-align: left;color: #8A2E26;">{{ item.date }} </div>
              <div class="timeline-item" v-for="(items, indexs) in item.list" :key='indexs'>
                <div class="date" style="color: #8A2E26;margin-top: 2px;">{{ items.ym }}</div>
                <div style="width: 10px;height: 10px;border-radius: 50%;border: 2px solid #8A2E26;margin: 0 20px;">
                </div>
                <div @click="clickbrand_event_info(items.id)">
                  <div>{{ items.title }}</div>
                </div>
              </div>

            </div>


          </div>
          <div v-if="activityIndex == 1">
            <div v-html="group_info.content"></div>
          </div>
          <div v-if="activityIndex == 2">


            <div style="padding: 40px 0;width: 60vw;position: relative;">

              <div v-for="(item, index) in brand_list" :key="index"
                style="margin: 17px;display: flex;justify-content: space-between;">
                <img :src="staticUrl + item.image" alt="" style="width: 270px;height: 160px;margin-right: 40px;">


                <div
                  style="flex: 1;text-align: left;display: flex;justify-content: space-between;flex-direction: column;">

                  <div style="color: #181818;font-size: 22px;">{{ item.title }}</div>
                  <div>{{ item.abstract }}</div>
                  <div @click="clickBrandInfo(item.id)"><a style="color: #666;">{{ zh_en == 'zh' ? '查看详情' : 'View details'
                      }}</a></div>
                </div>


              </div>


              <div style="position: absolute;bottom: 10px; left: 0;right: 0;margin: auto;">
                <el-pagination background layout="prev, pager, next" :total="companyTotal" :page-size="4"
                  @current-change="currentChange">
                </el-pagination>
              </div>
            </div>

          </div>
        </div>


        <div class="contentbox" v-if="isShowList == false && activityIndex == 0">
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 30px;">
            <div style="font-size: 36px;font-weight: 600;">
              {{ brand_event_info.title }}
            </div>
            <div @click="bcakList"
              style="background-color: rgba(138,46,38,0.05);color: rgba(138,46,38,1);font-size: 14px;border-radius: 5px;width: 120px;height: 40px;line-height: 40px;border: 1px solid rgba(138,46,38,1);">
              {{ zh_en == 'zh' ? '返回大事件' : 'back list' }}</div>
          </div>
          <div
            style=" width: 60px;background-color: rgba(255,255,255,1);border: 5px solid rgba(138,46,38,1);margin-bottom: 30px;;border-radius: 5px;margin-top: 10px;">
          </div>
          <div v-html="brand_event_info.content">

          </div>
        </div>

        <div class="contentbox" v-if="isShowList == false && activityIndex == 2">
          <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 30px;">
            <div style="font-size: 36px;font-weight: 600;">
              {{ brand_info.title }}
            </div>
            <div @click="bcakList"
              style="background-color: rgba(138,46,38,0.05);color: rgba(138,46,38,1);font-size: 14px;border-radius: 5px;width: 120px;height: 40px;line-height: 40px;border: 1px solid rgba(138,46,38,1);">
              {{ zh_en == 'zh' ? '返回列表' : 'back list' }}</div>
          </div>
          <div
            style=" width: 60px;background-color: rgba(255,255,255,1);border: 5px solid rgba(138,46,38,1);margin-bottom: 30px;;border-radius: 5px;margin-top: 10px;">
          </div>
          <div v-html="brand_info.content">

          </div>
        </div>

      </div>

    </div>

    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from '@/components/HomeFooter.vue';
import {
  get_group_info,
  get_brand_list,
  get_brand_info,
  get_brand_event_list,
  get_brand_event_info
} from "@/api/api";
export default {
  data() {
    return {
      tabList: this.zh_en == 'zh' ? ['大事件', '集团概况', '成员企业'] : ['The Event', 'Group Overview', 'Member Companies'],
      activityIndex: 0,
      group_info: '',
      isShowList: true,
      staticUrl: this.STATICURL,
      brand_info: '',
      brand_event_info: '',
      brand_list: [],
      brand_event_list: [],
      companyTotal: 0,
      postData: {
        page: 1,
        per_page: 4
      }

    }
  },
  components: {
    HomeFooter
  },
  mounted() {
    this.change(0)
  },
  methods: {
    clickBrandInfo(id) {
      this.isShowList = false
      get_brand_info({
        id: id
      }).then(res => {
        this.brand_info = res
      })
    },

    currentChange(e) {
      this.postData.page = e
      this.get_brand_list()
    },
    clickbrand_event_info(id) {
      this.isShowList = false
      get_brand_event_info({
        id: id
      }).then(res => {
        this.brand_event_info = res
      })
    },

    get_brand_event_list() {
      get_brand_event_list().then(res => {
        this.brand_event_list = res
      })
    },
    bcakList() {
      this.isShowList = true
    },
    get_brand_list() {
      get_brand_list(this.postData).then(res => {
        this.brand_list = res.data
        this.companyTotal = res.total
      })
    },
    change(e) {
      this.activityIndex = e;
      this.isShowList = true;
      this.postData.page = 1
      if (e == 0) {
        console.log('dashijian');
        this.get_brand_event_list()
      }
      if (e == 1) {
        this.get_group_info()

      }
      if (e == 2) {
        this.get_brand_list()
      }
    },
    get_group_info() {
      get_group_info().then((res) => {
        this.group_info = res
      })
    },
  }

}
</script>


<style lang="less" scoped>
.timeline-year {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.timeline-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.default {
  font-size: 15px;
  padding: 2px 0;
  display: flex;
  align-items: center;
  margin-left: 35px;
}

.activity {
  font-size: 17px;
  color: #8A2E26;
  border-bottom: 1px solid #8A2E26;
}

.content {
  width: 100%;
  padding: 48px;
  box-sizing: border-box;
  position: relative;

  .detail {
    .titlebox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding-bottom: 30px;
    }

    width: 60%;
    margin: 0 auto;
  }
}

.culture {}

.title {
  width: 100%;
  height: 360px;
  background-color: #d3dce6;

}
</style>